module.exports = __webpack_public_path__ + "img/mobile-wish-fill.033d2fb.svg?v=1750663372799";